import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompanyService } from '@services/company/company.service';
import { IS_API_REQUEST } from '@tokens/api-request.token';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);
  private companyService = inject(CompanyService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.context.get(IS_API_REQUEST)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === HttpStatusCode.Unauthorized) {
            void this.auth.toLoginPage(this.companyService.name);
          }
        }
        return throwError(() => error);
      }),
    );
  }
}
